<nav id="navbar"
     class="header-navbar navbar navbar-expand-lg align-items-center floating-nav navbar-light navbar-shadow">
  <div class="navbar-container d-flex content py-0">
    <div class="bookmark-wrapper d-flex align-items-center">
      <ul class="nav navbar-nav d-xl-none">
        <li class="nav-item"><a class="nav-link menu-toggle" href="javascript:void(0);" (click)="toggleMenuMovil($event)"><i class="ficon" data-feather="menu"></i></a></li>
      </ul>
      <!--ul class="nav navbar-nav bookmark-icons">
          <li class="nav-item d-none d-lg-block"><a class="nav-link" href="app-email.html" data-toggle="tooltip" data-placement="top" title="Email"><i class="ficon" data-feather="mail"></i></a></li>
          <li class="nav-item d-none d-lg-block"><a class="nav-link" href="app-chat.html" data-toggle="tooltip" data-placement="top" title="Chat"><i class="ficon" data-feather="message-square"></i></a></li>
          <li class="nav-item d-none d-lg-block"><a class="nav-link" href="app-calendar.html" data-toggle="tooltip" data-placement="top" title="Calendar"><i class="ficon" data-feather="calendar"></i></a></li>
          <li class="nav-item d-none d-lg-block"><a class="nav-link" href="app-todo.html" data-toggle="tooltip" data-placement="top" title="Todo"><i class="ficon" data-feather="check-square"></i></a></li>
      </ul>
      <ul class="nav navbar-nav">
          <li class="nav-item d-none d-lg-block"><a class="nav-link bookmark-star"><i class="ficon text-warning" data-feather="star"></i></a>
              <div class="bookmark-input search-input">
                  <div class="bookmark-input-icon"><i data-feather="search"></i></div>
                  <input class="form-control input" type="text" placeholder="Bookmark" tabindex="0" data-search="search">
                  <ul class="search-list search-list-bookmark"></ul>
              </div>
          </li>
      </ul-->
    </div>
    <ul class="nav navbar-nav align-items-center mr-auto">
      <li *ngIf="canal">
        <div class="d-flex align-items-center justify-content-start">
          <img *ngIf="canal.imagen_principal" [src]="canal.imagen_principal"
               [alt]="canal.nombre"
               class="tienda-logo" style="max-height: 40px">
          <h6 *ngIf="canal.nombre" class="tienda-nombre mb-0 ml-1">{{ canal.nombre }}</h6>
        </div>
      </li>
    </ul>

    <ul class="nav navbar-nav align-items-center ml-auto">
      <li class="nav-item dropdown dropdown-user">
        <div ngbDropdown class="d-inline-block">
          <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" href="javascript:void(0);"
             ngbDropdownToggle data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="user-nav d-sm-flex d-none">
              <span
                class="user-name font-weight-bolder">{{ this.usuario.usuario.nombres }} {{ this.usuario.usuario.apellidos }}</span>
              <!--span class="user-status">Admin</span-->
            </div>
            <span class="avatar">
                      <img class="round" src="{{this.usuario.usuario.imagen}}" alt="avatar" height="40" width="40"><span
              class="avatar-status-online"></span></span>
          </a>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <a class="dropdown-item" ngbDropdownItem routerLink="/admin/user/profile"><i class="mr-50"
                                                                                         data-feather="user"></i> Perfil</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" ngbDropdownItem (click)="cerrarSesion()"><i class="mr-50" data-feather="power"></i>
              Cerrar sesión</a>
          </div>
        </div>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdown-user">

        </div>
      </li>
    </ul>
  </div>
</nav>
